module.exports = __webpack_public_path__ + "img/mobile-elbow-22_68x52.ae63ab0a.png";